module.exports = __webpack_public_path__ + "img/RENAULT.4c7977b.jpg";